import React from 'react';


const Logo = (props={})=>{

    const {id=''} = props;

    return (
        <div className={"logo-container"}>
            <img className="logo-img" src='./images/logo.png' />
        </div>
    )

}

export {Logo}